<template>
  <div class="bottom-image-container" :class="product.match ? 'match' : 'default'">
    <!-- <div class="bottom-image-wrapper"> -->
      <lazy-image :url="product.products[0].image"/>
      <!-- <img class="bottom-image-image" :src="product.products[0].image" alt=""> -->
    <!-- </div> -->
    <div style="margin-top: 0.5em;">
      <div>
        <p>{{ `${product.products[0].seller.name} (${product.products[0].seller.id})` }}</p>
        <a class="product-url-link" :href="product.products[0].url" target="_blank">{{ product.products[0].name }}</a>
        <p>Distancia: {{ product.distance }}</p>
      </div>
    </div>
    <base-button @click.prevent="toogleMatch">
      {{ product.match ? 'Unmatch' : 'Match' }}
    </base-button>
  </div>
</template>
<script>
import LazyImage from '@/components/LazyImage'
export default {
  components: {
    LazyImage
  },
  props: {
    product: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    toogleMatch() {
      this.$emit('matchFromBottom')
    }
  }
}
</script>
<style scoped>
.bottom-image-container {
  width: 17.5em;
  overflow: hidden;
  color: #fff;
  padding: 1em;
  margin: 10px;
  transition: transform 0.5s, background-color 1s, box-shadow 0.5s;
  box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.5);
}
.default {
  background-color: #621f65;
}
.selected {
  background-color: #ea1d75;
}
.match {
  background-color: #00948F;
}
</style>
